<!-- bbs,안전리더십 > 모니터링설정 > 행동불러오기 팝업 -->
<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{ popTitle }}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>
      <!--content-->
      <v-card-text>
        <div class="tab-group ty01">
          <v-tabs
            v-model="tab"
          >
            <v-tab value="tabCont1">{{t('message.library')}}({{ libraryCnt }})</v-tab>
            <v-tab value="tabCont2" >{{t('message.monitoring')}}({{ monitoringCnt }})</v-tab>
          </v-tabs>
        </div>
        <div class="content-box bg-none">
          <v-tabs-window v-model="tab">
            <v-tabs-window-item value="tabCont1">
              <c-Input :placeholder="t('message.enterBehaviorOrTag')" v-model="searchModel" @search-word="onClickSearch" @keyup.enter="onClickSearch" :name="'searchWord'"/>
              <div class="dropdown-group ty01">
                <v-list v-model:opened="open">
                  <!--depth1 -->
                  <v-list-group v-for="(itemD1, seqD1) in filterArray(1)" :key="'depth1'+itemD1.idx">
                    <template v-slot:activator="{ props }">
                      <v-list-item v-bind="props" :title="itemD1.behaviorTitle" :class="itemD1.selected?'on':''">
                        <div class="check-group">
                          <v-checkbox
                            :model-value="itemD1.selected"
                            @click.stop="toggleDepth1(itemD1, 1)"
                          ></v-checkbox>
                        </div>
                      </v-list-item>
                    </template>
                    <!--depth2 -->
                    <v-list-group v-for="(itemD2, seqD2) in filterSortArray(itemD1.sortType)">
                      <template v-slot:activator="{ props }">
                        <v-list-item v-bind="props" :title="itemD2.behaviorTitle" :class="['hidden-icon', { on: itemD2.selected }]">
                          <div class="check-group">
                            <v-checkbox
                              :model-value="itemD2.selected"
                              @click.stop="toggleDepth2(itemD2, itemD1, 1)"
                            ></v-checkbox>
                          </div>
                        </v-list-item>
                      </template>
                    </v-list-group>
                    <!--depth2 -->
                  </v-list-group>
                  <!--depth1 -->
                </v-list>
              </div>
            </v-tabs-window-item>
            <v-tabs-window-item value="tabCont2">
              <c-Input :placeholder="t('message.enterBehaviorOrTag')" :name="'searchTag'"/>
              <div class="dropdown-group ty01">
                <v-list v-model:opened="open">
                  <!--depth1 -->
                  <v-list-group v-for="(itemD1, seqD1) in filterArray2(1)" :key="'depth2'+itemD1.idx">
                    <template v-slot:activator="{ props }">
                      <v-list-item v-bind="props" :title="itemD1.behaviorTitle" :class="itemD1.selected?'on':''">
                        <div class="check-group">
                          <v-checkbox
                            :model-value="itemD1.selected"
                            @click.stop="toggleDepth1(itemD1, 2)"
                          ></v-checkbox>
                        </div>
                      </v-list-item>
                    </template>
                    <!--depth2 -->
                    <v-list-group v-for="(itemD2, seqD2) in filterSortArray2(itemD1.sortType)">
                      <template v-slot:activator="{ props }">
                        <v-list-item v-bind="props" :title="itemD2.behaviorTitle" :class="['hidden-icon', { on: itemD2.selected }]">
                          <div class="check-group">
                            <v-checkbox
                              :model-value="itemD2.selected"
                              @click.stop="toggleDepth2(itemD2, itemD1, 2)"
                            ></v-checkbox>
                          </div>
                        </v-list-item>
                      </template>
                    </v-list-group>
                    <!--depth2 -->
                  </v-list-group>
                  <!--depth1 -->
                </v-list>
              </div>
            </v-tabs-window-item>
          </v-tabs-window>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class="d-flex justify-end pop-bottom-bg"><!--pop-bottom-bg-->
        <c-btn01 v-bind="btnSave" @click.prevent.stop="handleForm"/>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>

</template>

<script setup lang="ts">
import {ref, computed, watch} from 'vue'
import BbsService from "@/services/bbs.service";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps(['popTitle'])
const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const tab:any = ref(null)
const open = ref(['open'])
const items = ref([])
const items2 = ref([])
const libraryCnt = ref(0)
const monitoringCnt = ref(0)
const searchModel = ref(null)
let selectedArr = []
let selectedArr2 = []
const snackbar = ref(false)
const snackText = ref('')

//ui
const btnSave = ref({
  btnText: computed(() => t('message.save')),
})

//hook
onBeforeUpdate (()=>{
  items.value = []
  items2.value = []
  tab.value = 'tabCont1'
})

onUpdated (() => {
  if(dialog.value) {
    //storeRef.popupItems.value = [] -> 이걸 왜 넣었을까? 없어서 기존데이터 수정할때 초기화된다
    onClickSearch()
  }
})

//watch
watch(items, (newValue:any) => {
  if(newValue.selected && _.find(selectedArr, {idx:newValue.idx})){
    snackText.value = t('message.actionAlreadyAdded')
    snackbar.value = true
    newValue.selected = false
  }
  else {
    selectedArr = _.filter(items.value, {selected: true, treeLevel: 2})
    libraryCnt.value = selectedArr.length
  }
}, {deep: true})

watch(items2, (newValue:any) => {
  if(newValue.selected && _.find(selectedArr2, {idx:newValue.idx})){
    snackText.value = t('message.actionAlreadyAdded')
    snackbar.value = true
    newValue.selected = false
  }
  else {
    selectedArr2 = _.filter(items2.value, {selected: true, treeLevel: 2})
    monitoringCnt.value = selectedArr2.length
  }
}, {deep: true})

watch(tab, (newValue) => {
  if(dialog.value)
    onClickSearch()
})

//computed
const filterArray = computed(()=>(param) => {return _.filter(items.value, {treeLevel: param}) })
const filterSortArray = computed(()=>(param) => {return _.filter(items.value, {sortType: param, treeLevel:2}) })
const filterMonitoringArray = computed(()=>(param) => {return _.filter(items.value, {monitoringIdx: param, treeLevel:2}) })
const filterArray2 = computed(()=>(param) => {return _.filter(items2.value, {treeLevel: param}) })
const filterSortArray2 = computed(()=>(param) => {return _.filter(items2.value, {sortType: param, treeLevel:2}) })
const filterMonitoringArray2 = computed(()=>(param) => {return _.filter(items2.value, {monitoringIdx: param, treeLevel:2}) })

//function
const onClickSearch=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let monitoringType = storeRef.moduleType.value
  let params = {
    companyIdx: companyIdx,
    keyword:searchModel.value,
    actionType:monitoringType
  }

  if(tab.value == 'tabCont1') {
    BbsService.getBehaviorList(params).then(
      (response) => {
        items.value = response.result
        items.value.push({behaviorTitle: t('message.behavior'), sortType: '1', treeLevel: 1})
        items.value.push({behaviorTitle: t('message.status'), sortType: '2', treeLevel: 1})

        const oriArr = storeRef.popupItems.value
        items.value.forEach((item, key)=>{
          if (_.find(oriArr, {idx: item.idx}))
            item.selected = true
        })
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
  else if(tab.value == 'tabCont2') {
    const companyIdx = localStorage.getItem('companyIdx')
    let params2 = {companyIdx: companyIdx, actionType:monitoringType}
    //bbs 모니터링
    if(monitoringType == '1') {
      BbsService.getMonitoringFilter(params2).then(
        (response) => {
          items2.value = []
          let bbsList = response.result.monitoringList
          _.forEach(bbsList, (item) => {
            items2.value.push({behaviorTitle: item.monitoringTitle, sortType: item.idx, treeLevel: 1})
            _.forEach(item.behaviors, (item2) => {
              items2.value.push({...item2, sortType: item.idx, treeLevel: 2})
            })
          })

          const oriArr = storeRef.popupItems.value
          items2.value.forEach((item, key) => {
            if (_.find(oriArr, {idx: item.idx}))
              item.selected = true
          })
        },
        (error) => {
          if (error.status == 403)
            utils.movePage('/login')
          else {
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
    }
    else if(monitoringType == '2') {
      LeadershipService.getMonitoringListFilter(params2).then(
        (response) => {
          items2.value = []
          let monitoringList = response.result.monitoringList
          _.forEach(monitoringList, (item) => {
            if(item.behaviorList?.length > 0)
              items2.value.push({behaviorTitle: `${item.leadershipTitle??''} > ${item.contentTitle??''}`, sortType: item.idx, treeLevel: 1})
            _.forEach(item.behaviorList, (item2) => {
              items2.value.push({...item2, sortType: item.idx, treeLevel: 2})
            })
          })

          const oriArr = storeRef.popupItems.value
          items2.value.forEach((item, key) => {
            if (_.find(oriArr, {idx: item.idx}))
              item.selected = true
          })
        },
        (error) => {
          if (error.status == 403)
            utils.movePage('/login')
          else {
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
    }
  }
}

const handleForm=()=> {
  if (import.meta.env.MODE == 'development') {
    emit('close', '')
  } else {
    let tab1 = _.filter(items.value, {selected: true, treeLevel:2})
    let tab2 = _.filter(items2.value, {selected: true, treeLevel:2})
    let resultItems = _.concat(tab1, tab2)
    resultItems = _.uniqBy(resultItems, 'idx')
    emit('confirm', resultItems)
  }
}

const toggleDepth1 = (itemD1, listType) => {
  itemD1.selected = !itemD1.selected
  let childList = []
  if(listType == 1)
    childList = filterSortArray.value(itemD1.sortType)
  else if(listType == 2)
    childList = filterSortArray2.value(itemD1.sortType)
  childList.forEach((child) => {
    child.selected = itemD1.selected
  })
}

const toggleDepth2 = (itemD2, itemD1, listType) => {
  itemD2.selected = !itemD2.selected
  let childList = []
  if(listType == 1)
    childList = filterSortArray.value(itemD1.sortType)
  else if(listType == 2)
    childList = filterSortArray2.value(itemD1.sortType)
  itemD1.selected = childList.every((child) => child.selected)
}
</script>


<style lang="scss">

</style>
